var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M13.664 7.636a4 4 0 0 0 1.03 1.714l-3.357 2.014a4 4 0 0 0-1.03-1.714zM10.307 15.35l3.357 2.014a4 4 0 0 1 1.03-1.714l-3.357-2.014a4 4 0 0 1-1.03 1.714"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M17.5 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2a4 4 0 1 1-8 0 4 4 0 0 1 8 0M17.5 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2a4 4 0 1 1-8 0 4 4 0 0 1 8 0M7.5 14.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconShare;